import { forwardRef } from "react";

import { NumberField as BaseNumberField } from "@base-ui/react/number-field";
import { MinusIcon } from "@eisox/icons";

import { cn } from "..";

const NumberFieldDecrement = forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithRef<typeof BaseNumberField.Decrement>
>((props, forwardedRef) => {
  const { className, children, ...decrementProps } = props;
  return (
    <BaseNumberField.Decrement
      {...decrementProps}
      ref={forwardedRef}
      className={cn(
        "w-11 flex cursor-pointer items-center justify-center border-none bg-transparent text-primary-dark-gray transition-colors",
        "hover:bg-primary-gray hover:text-primary-dark-blue disabled:cursor-not-allowed disabled:bg-transparent disabled:opacity-50",
        "[&>svg]:h-4 [&>svg]:w-4",
        className,
      )}
    >
      {children ?? <MinusIcon />}
    </BaseNumberField.Decrement>
  );
});

NumberFieldDecrement.displayName = "NumberField.Decrement";

export default NumberFieldDecrement;
